import { request } from "../utils/request";
import { getNewEndpoint } from "../config/newEndpoint";

async function trial(params) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: NEW_ENDPOINT.TRIALS,
    method: "get",
    params,
  });
}

async function updateTrial(data, token) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: `${NEW_ENDPOINT.BILLING}/api/v4.1/trials`,
    method: "post",
    data,
    headers: {
      "X-Auth-Token": token,
    },
  });
}

export default {
  trial,
  updateTrial,
};
